import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

/** Manual GA4 page views, including client-side React Router navigations. */
export default function AnalyticsPageViews() {
  const location = useLocation();

  useEffect(() => {
    // Let route-level SEO effects update document.title first. The cleanup also
    // prevents redirects/replaces from counting their transient source URL.
    const timer = window.setTimeout(() => trackPageView(location.key), 0);
    return () => window.clearTimeout(timer);
  }, [location.key]);

  return null;
}
